import Image from 'next/image'
import Link from 'next/link'
import clsx from 'clsx'

import WidthLimiter from 'containers/width-limiter/width-limiter'
import Button from '../../parts/button/button'
import usePCWindow from 'hooks/usePCWindow'

import { STATIC_URL, URL_SITE } from 'constants/data'
import { ScreenSize } from 'constants/media-constanst'
import { A_cc_openClinCase, originClinCase } from 'utils/analytics/clincase/clincase'
import { A_mu_buttons, buttonsUnauth } from 'utils/analytics/main_unauth/main_unauth'

import styles from './intro-clincase.module.scss'
import stylesCommon from 'styles/main.module.scss'

const clincaseImg = {
  src: `${STATIC_URL}/intro-alt/necessary/clincase.png`,
  width: 540,
  height: 236,
  alt: 'clincase',
}

const clincaseImgMob = {
  src: `${STATIC_URL}/intro-alt/necessary/clincase-mob.png`,
  width: 540,
  height: 231,
  alt: 'clincase',
}

const circleImg = {
  src: `${STATIC_URL}/intro-alt/necessary/circle.png`,
  width: 162,
  height: 118,
  alt: 'circle',
}
const IntroClincase = () => {
  const isDesktop = usePCWindow(ScreenSize.big)

  const GAHandler = (id: number) => {
    A_cc_openClinCase(originClinCase.LANDING, id)
  }

  return (
    <WidthLimiter noBottomPadding noTopPadding>
      <h2 className={stylesCommon.title}>Клинические случаи</h2>
      <div className={styles.top}>
        <div className={clsx(styles.cardCommon, styles.topFirst)}>
          {isDesktop ? (
            <Image className={styles.clincaseImg} {...clincaseImg} />
          ) : (
            <Image className={styles.clincaseImg} {...clincaseImgMob} />
          )}
          <div>
            <span className={styles.spec}>Гериатрия</span>
            <span className={styles.spec}>Гастроэнтерология</span>
          </div>
          <div>
            <span className={styles.spec}>Травматология и ортопедия</span>
          </div>
          <div>
            <span className={styles.spec}>Эндокринология</span>
          </div>
          <div>
            <span className={styles.spec}>Кардиология</span>
          </div>
          <div>
            <span className={clsx(styles.spec, styles.specLast)}>И другие</span>
          </div>
        </div>
        <div className={clsx(styles.cardCommon)} onClick={() => GAHandler(57)}>
          <Link href={'/clinical-case/57'} target="_blank">
            <div className={styles.fio}>Отмена или смена? Миопатия на фоне статинов</div>
            <div className={styles.txt}>
              Добрый вечер. Пациентке 60 лет с ИБС. ГБ 3 ст. Дислипидемия. СД 2 тип. Впервые был
              назначен розувастатин 10 мг, через месяц приема появились сильные боли в мышцах рук,
              больная не могла самостоятельно одевать. Пациентка сама отменила препарат, боли через
              месяц прошли. Как быть.
            </div>
            <div className={styles.next}>Читать далее</div>
          </Link>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={clsx(styles.cardCommon, styles.bottomFirst)} onClick={() => GAHandler(51)}>
          <Link href={'/clinical-case/51'} target="_blank">
            <div className={styles.fio}>
              Не работает лечение: хроническая хеликобактер-ассоциированная язва
            </div>
            <div className={styles.txt}>
              Здравствуйте. Пациентка 60 лет: язвенная болезнь 12 перст. кишки в течении 20 лет.
              Ежегодные обострения с 2018года. Хеликобактр определяется при ФГС или при определении
              титра ХБ в кале, несмотря на проводимое современное ...
            </div>
            <div className={styles.next}>Читать далее</div>
          </Link>
        </div>
        <div className={clsx(styles.cardCommon)} onClick={() => GAHandler(50)}>
          <Link href={'/clinical-case/50'} target="_blank">
            <div className={styles.fio}>Тяжелая ИМП у пожилой пациентки</div>
            <div className={styles.txt}>
              Добрый день коллеги. У пациентки 72 лет СД 2 типа, ГБ 2ст, постоянно принимала ...
            </div>
            <div className={styles.next}>Читать далее</div>
          </Link>
        </div>
        <div className={clsx(styles.cardCommon, styles.bottomLast)}>
          <Image className={styles.circle} {...circleImg} />
          <div className={styles.fio}>
            Поделитесь своим клиническим кейсом и станьте частью сообщества!
          </div>
          <Link href={`${URL_SITE}/medpulse`} target="_blank">
            <Button onClick={() => A_mu_buttons(buttonsUnauth.SHARE)} modificator={styles.modBtn}>
              Поделиться
            </Button>
          </Link>
        </div>
      </div>
    </WidthLimiter>
  )
}

export default IntroClincase
